import PropTypes from 'prop-types';
import React from 'react';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import Report from '../../../../common/components/Report';

const PredesImpcCodeUsageNonComplianceReport = props => (
  <Report
    id={props.id}
    tabs={[
      {
        value: ReportDefinitions.PREDES_IMPC_CODE_USAGE_NON_COMPLIANCE_SUMMARY.id,
        label: 'SUMMARY',
      },
      {
        value: ReportDefinitions.PREDES_IMPC_CODE_USAGE_NON_COMPLIANCE_DETAILS.id,
        label: 'DETAILS',
        loadFromTable: true,
        loadFromTableMessage: 'app.warning.load.from.summary.report',
      },
    ]}
    {...props}
  />
);
export default PredesImpcCodeUsageNonComplianceReport;

PredesImpcCodeUsageNonComplianceReport.propTypes = {
  id: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  generatedOnDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  reportId: PropTypes.string,
};
